export default __webpack_public_path__ + "static/media/img3.82afd48f.png";